import { IPatientCondition } from 'app/shared/model/patient-condition.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IAdmission } from 'app/shared/model/admission.model';
import { ClinicalStatus } from 'app/shared/model/enumerations/clinical-status.model';
import { VerificationStatus } from 'app/shared/model/enumerations/verification-status.model';
import { ConditionCategory } from 'app/shared/model/enumerations/condition-category.model';
import { ConditionSeverity } from 'app/shared/model/enumerations/condition-severity.model';

export interface IPatientConditionCheckUp {
  id?: string;
  active?: boolean;
  microSec?: number;
  lastupdated?: number;
  timestampentry?: number;
  cursor?: number;
  stageType?: string;
  observationSummary?: string;
  clinicalStatus?: keyof typeof ClinicalStatus | null;
  verificationStatus?: keyof typeof VerificationStatus | null;
  conditionCategory?: keyof typeof ConditionCategory | null;
  conditionSeverity?: keyof typeof ConditionSeverity | null;
  patientCondition?: IPatientCondition;
  diagnosisReport?: ILabPrescription;
  vitals?: IVitals | null;
  reportedBy?: IDoctor | null;
  encounter?: IAppointments | null;
  ipEncounter?: IAdmission | null;
}

export const defaultValue: Readonly<IPatientConditionCheckUp> = {
  active: false,
};
